import IFetchPropertyRecordsTask = ZoningAPI.IFetchPropertyRecordsTask;
import IPerformanceStatistic = ZoningAPI.IPerformanceStatistic;
import { Task } from './task';

export class FetchPropertyRecordsTask extends Task implements IFetchPropertyRecordsTask {
    municipalityId: number;
    responseLimit: number;
    gridicsApiLimit: number;
    limit: number;
    callback: string;
    offset: number;
    currentOffset: number;
    zoningCodeRecords: number;
    expectedRecords: number;
    currentExpectedRecords: number;
    receivedRecords: number;
    sendRecords: number;
    maxEmptyResultAttempts: number;
    emptyResultAttempts: number;
    performance?: IPerformanceStatistic;
}
